import { useMemo } from "react";

export interface RoleFlags {
    isStudent: boolean;
    isAgent: boolean;
    isApplicant: boolean;
    isSuperadmin: boolean;
    isAdmin: boolean;
    isStaff: boolean;
    isAccountOrTrainer: boolean;
    isTrainer:boolean;
    isAccount:boolean;
}

export const useRoleFlags = (roles: string[]): RoleFlags => {
    return useMemo(() => ({
        isStudent: roles.includes('Student'),
        isAgent: roles.includes('Agent'),
        isApplicant: roles.includes('Student') || roles.includes('Agent'),
        isSuperadmin: roles.includes('Superadmin'),
        isAdmin: roles.includes('Superadmin') || roles.includes('Admin'),
        isStaff: roles.length > 0 && !roles.includes('Student') && !roles.includes('Agent'),
        isAccountOrTrainer: roles.some(r => r === 'Account' || r === 'Trainer'),
        isTrainer:roles.includes('Trainer'),
        isAccount:roles.includes('Account'),
    }), [roles]);
};
